
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-path":"url(#clip0)","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M.75 4a.75.75 0 01.75-.75h18a.75.75 0 01.75.75v12a.75.75 0 01-.75.75h-18A.75.75 0 01.75 16V4zm1.5.75v10.5h16.5V4.75H2.25z"}}),_c('path',{attrs:{"d":"M.75 7.274a.75.75 0 01.75-.75h18a.75.75 0 010 1.5h-18a.75.75 0 01-.75-.75zm3.6 3.266a.75.75 0 01.75-.75h6.6a.75.75 0 110 1.5H5.1a.75.75 0 01-.75-.75zm0 2.19a.75.75 0 01.75-.75h4.2a.75.75 0 010 1.5H5.1a.75.75 0 01-.75-.75z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z","transform":"translate(.5)"}})])])])
          )
        }
      }
    